export default __webpack_public_path__ + "static/media/December2014.28754a41.png";